import { getConfig } from '@klpkonsern/appconfig';
import type { Client } from '@klp/client';
import { isIntercomEnabled } from '@klp/client/config';

export const updateSelectedCustomer = (customer: Client) => {
    if (!isIntercomEnabled()) return;

    window['Intercom']('update', {
        app_id: getConfig('WEBAPP_INTERCOM_APP_ID', ''),
        last_selected_customer: customer.kundeNummer,
    });
};
